import { Button } from "@/components/ui/button";
import { useLocation } from "react-router-dom";
import { getPlanityUrl } from "@/config/standort";

const CallToAction = () => {
  const location = useLocation();
  const planityUrl = getPlanityUrl();
  return (
    <section className="py-24 md:py-32 bg-charcoal text-background relative z-10">

      <div className="container px-6">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          {/* Decorative */}
          <div className="flex items-center justify-center gap-4 mb-4">
            <span className="w-12 h-px bg-primary" />
            <span className="text-sm tracking-wide uppercase text-background/60 font-medium">
              Bereit?
            </span>
            <span className="w-12 h-px bg-primary" />
          </div>

          <h2 className="text-heading md:text-display font-serif font-light">
            Zeit für dich.
            <br />
            <span className="text-primary">Zeit für Schönheit.</span>
          </h2>

          <p className="text-lg md:text-xl text-background/70 font-light max-w-xl mx-auto">
            Buche jetzt deinen Termin und erlebe Beauty auf einem neuen Niveau.
          </p>

          <div className="pt-4">
            <Button
              size="lg"
              className="bg-primary text-primary-foreground hover:bg-blush-dark px-10 py-6 text-base font-medium rounded-full hover-lift shadow-glow"
              onClick={() => window.open(planityUrl, '_blank')}
            >
              Termin buchen
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
